var App = App || {};

App.LoginForm = (function ($) {
    'use strict';

    function Init() {
        var $accountSelects = $('[id^="account-select-"]');

        $accountSelects.each(function() {
            var $select = $(this);
            var $form = $select.parents("form");
            var $loginPanels = $form.find(".login-panel");

            showPanel($select.val(), $loginPanels, $form);

            $select.on("change", function() {
                showPanel($(this).val(), $loginPanels, $form);
            });
        });

        function showPanel(panelId, $panels, $form) {
            $panels.hide();
            
            $form.find("#" + panelId).show();
            
            var urlAttribute = "data-" + panelId + "-url";
            var newAction = $form.attr(urlAttribute);

            if (newAction) {
                $form.attr("action", newAction);
            }
            
            if (panelId === "treasury-management") {
                $form.attr("method", "get");
            } else {
                $form.attr("method", "post");
            }
        }
    }

    return {
        Init: Init
    };
})(jQuery);